import { useEffect, useLayoutEffect } from 'react';

/**
 * `useLayoutEffect` on the client, `useEffect` on the server.
 *
 * useLayoutEffect fires synchronously after DOM mutations but BEFORE the browser
 * paints, so it's the right hook for reading layout (measuring an element) and
 * writing a style back without a visible flash. It's a no-op on the server, and
 * React warns when it runs during SSR — so on the server (the store app is
 * server-rendered) we fall back to useEffect, which runs after hydration where
 * there is finally a layout to measure.
 */
const useIsomorphicLayoutEffect = typeof document !== 'undefined' ? useLayoutEffect : useEffect;

export default useIsomorphicLayoutEffect;
